// @flow
import * as React from 'react'

type Props = {
  name: string,
  pronouns?: string,
  photo: string,
  jobTitle: React.Node,
  hobby: React.Node,
  children: React.Node,
  linkedin: string,
}

export const Teammember = (props: Props): React.Element<'div'> => (
  <div className="team-panel px-xxl-5 col-xl-5 col-md-6 col-12 mb-5">
    <div className="text-center">
      <div className="px-3 mb-3">
        <img src={props.photo} alt={props.name} className="rounded-circle img-fluid" style={{ maxWidth: '190px' }} />
      </div>
      <div className="d-flex flex-shrink-1 justify-content-center align-items-baseline mb-2">
        <div className="position-relative">
          <h2 className="text-aqua mb-0">{props.name}</h2>
          {props.pronouns && (
            <span
              style={{ transform: 'translate(100%, -40%)' }}
              className="text-muted small position-absolute top-50 end-0 ps-1"
            >
              {props.pronouns}
            </span>
          )}
        </div>
      </div>
      <h4 className="fw-bold text-blue mb-0">{props.jobTitle}</h4>
      <h5 className="my-2 subtitle text-muted mb-2">{props.hobby}</h5>
      <a href={props.linkedin} target="_blank" className="social-media-link" rel="noreferrer">
        <i className="fa fa-linkedin-square-blue" />
      </a>
    </div>
    <div style={{ fontSize: '1.05rem' }}>{props.children}</div>
  </div>
)
